import { makeStyles } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import MessagesContext from '../../../contexts/messagesContext';
import { MainDialog } from '../../UI';
import { PropTypes } from 'prop-types';
import { deleteForm } from '../../../redux/DynamicForms/DynamicFormsAction';
import { useDispatch } from 'react-redux';

const styles = makeStyles({
    dialogButtons: {
        width: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginRight: 'auto',
        marginBottom: '30px',
        '& > button': {
            width: '48%',
            padding: '7px 0',
            borderRadius: '6px',
            fontFamily: 'inherit',
            fontSize: '14px',
            fontWeight: 'bold',
            lineHeight: 1.79,
            cursor: 'pointer'
            // outline: 'none'
        }
    },
    deleteButton: {
        border: 'solid 1.5px #ee384e',
        backgroundColor: '#ee384e',
        color: '#fff',
        '&:disabled': {
            backgroundColor: '#ee384e',
            color: '#fff',
            opacity: '0.5'
        }
    },
    cancelButton: {
        border: 'solid 1.5px #509ffa',
        backgroundColor: '#fff',
        color: '#509ffa'
    },
    deleteInputWrapper: {
        display: 'flex',
        flexDirection: 'column',
        '& input': {
            width: '50%',
            padding: '9px 12px',
            borderRadius: '4px',
            border: 'solid 1.5px rgba(206, 210, 214, 0.8)',
            marginBottom: '24px',
            direction: 'ltr'
        }
    },
    deleteTite: {
        margin: '16px 0 5px 0',
        fontFamily: 'inherit',
        fontSize: '15px',
        color: '#232733'
    },
    textWrapper: {
        fontFamily: 'inherit',
        fontWeight: 'normal',
        lineHeight: 1.69,
        letterSpacing: 'normal',
        display: 'flex',
        marginBottom: '10px',
        '& > span': {
            margin: '0 2px',
            wordSpacing: '2px'
        }
    },
    normalText: {
        fontSize: '13px',
        color: '#232733'
    },
    boldText: { fontSize: '14px', color: 'black', fontWeight: 'bold' },
    warningText: { fontSize: '13px', color: '#ee384e' }
});

const DeleteFormDialog = ({ setDeleteDialog, deleteDialog, formName, title }) => {
    const classes = styles();
    const { messages } = useContext(MessagesContext);
    const [showDeleteInput, setShowDeleteInput] = useState(false);
    const [message, setMessage] = useState('');
    const dispatch = useDispatch();

    const handleBack = () => {
        setDeleteDialog(false);
        setMessage('');
        if (showDeleteInput) {
            setShowDeleteInput(false);
        }
    };
    const handleInput = (e) => {
        setMessage(e.target.value.toLowerCase());
    };
    const handleDeleteForm = () => {
        if (message?.length > 1 && message === 'delete') {
            dispatch(deleteForm(formName));
            setShowDeleteInput(false);
            setDeleteDialog(false);
            setMessage('');
        } else {
            setShowDeleteInput(true);
        }
    };

    const deleteText = () => {
        return (
            <>
                <div className={classes.textWrapper}>
                    <span className={classes.normalText}>{messages.deleteFormDialog.text1}</span>
                    <span className={classes.boldText}>{title}</span>
                    <span className={classes.normalText}>{messages.deleteFormDialog.text3}</span>
                    <span className={classes.warningText}>{messages.deleteFormDialog.text4}</span>
                    <span className={classes.normalText}>{messages.deleteFormDialog.text5}</span>
                </div>
                <div className={classes.textWrapper}>
                    <span className={classes.normalText}>{messages.deleteFormDialog.text6}</span>
                    <span className={classes.warningText}>{messages.deleteFormDialog.text7}</span>
                </div>
                <div className={classes.textWrapper}>
                    <span className={classes.boldText}>{messages.deleteFormDialog.text8}</span>
                </div>
            </>
        );
    };

    return (
        <>
            <MainDialog
                title={messages.deleteForm}
                open={deleteDialog}
                goBack={handleBack}
                minHeight={'200px'}
            >
                {deleteText()}
                {showDeleteInput && (
                    <div className={classes.deleteInputWrapper}>
                        <span className={classes.normalText}>
                            {messages.deleteFormDialog.message}
                        </span>
                        <span className={classes.deleteTite}>Delete</span>
                        <input type="text" onChange={handleInput} data-testid="input" autoFocus />
                    </div>
                )}
                <div className={classes.dialogButtons}>
                    <button className={classes.cancelButton} onClick={handleBack}>
                        {messages.back}
                    </button>
                    <button
                        className={classes.deleteButton}
                        onClick={handleDeleteForm}
                        disabled={showDeleteInput && message !== 'delete'}
                        data-testid="deleteForm"
                    >
                        {messages.deleteForm}
                    </button>
                </div>
            </MainDialog>
        </>
    );
};
DeleteFormDialog.propTypes = {
    setDeleteDialog: PropTypes.func,
    deleteDialog: PropTypes.bool,
    formName: PropTypes.string,
    title: PropTypes.string
};

export default DeleteFormDialog;
